require('./entry-bsc-card-ts');



//////////////////
// WEBPACK FOOTER
// ./src/entry-bsc-card.js
// module id = 542
// module chunks = 0